angular
	.module('empower.contactUs')
	.constant('customerCareInfoConst', {
		ALL: {
			name: 'NATIONAL',
			phones: [
				'<b>VIC:</b>(03) 7000 0698',
				'<b>NSW:</b>(02) 8251 9265'
			],
			emails: [
				'empower@eml.com.au'
			]
		},
		VIC: {
			name: 'VICTORIA',
			phones: [
				'(03) 7000 0698'
			],
			emails: [
				'PremiumVIC@eml.com.au',
				'ClientServicesVIC@eml.com.au',
				'CustomerCareVic@eml.com.au'
			]
		},
		NSW: {
			name: 'NEW SOUTH WALES',
			phones: [
				'(02) 8251 9265'
			],
			emails: [
				'empower@eml.com.au'
			]
		},
		NSI: {
			name: '',
			phones: [
				'1800 469 931 (toll free)'
			],
			emails: [
				'info@eml.com.au'
			]
		},
		WORKER: {
			name: '',
			phones: [
				'1800 469 931 (toll free)'
			],
			emails: [
				'info@eml.com.au'
			]
		}
	});